const zIndex = {};

export default zIndex;
